import { Label } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'


const ScanInfo = ({orderItem, scanValue, ...props}) => {
    const [t] = useTranslation()

    if (scanValue === undefined) {
        return null
    }

    return <Label
      className={props.className}
      color={scanValue < orderItem.quantity ? 'yellow' : 'green'}
      size="mini"
      icon="tablet alternate"
      content={t('order.pickup.scanned_label')}
      detail={orderItem.quantity > 0 && `${scanValue}/${orderItem.quantity}`}
    />
}

ScanInfo.propTypes = {
    orderItem: PropTypes.shape({
        quantity: PropTypes.number.isRequired,
    }).isRequired,
    scanValue: PropTypes.number,
}

export { ScanInfo }
